import CreateLTLRule from "../../views/carriersRules/components/CreateLTLRule.vue";

const createLTLRuleRoute = [
  {
    path: "/ltl-rule",
    name: "CreateLTLRule",
    component: CreateLTLRule,
  },
];

export default createLTLRuleRoute;
